<template>
  <a
    :href="campaign.click_url"
    :class="`d-block card campaign campaign-ad border-0 variant-${variant}`"
    target="_blank"
  >
    <span
      v-if="!campaign.image"
      :style="`background-color: ${campaign.bgcolor} !important; color: ${campaign.textcolor}`"
      class="ad-content d-flex flex-column justify-content-center align-items-center p-4"
    >
      <span
        :class="`${headlineSize} mb-0 font-weight-normal`"
        v-html="campaign.headline"
      ></span>
    </span>
    <span
      v-else
      class="ad-content d-flex flex-column justify-content-center align-items-center overflow-hidden"
      :style="`color: ${campaign.textcolor}`"
    >
      <span
        class="ad-content-bg"
        :style="`background-image:url(${campaign.image});`"
      ></span>
      <span
        class="ad-content-cover"
      ></span>
      <img
        class="ad-content-image"
        :src="campaign.image"
      >
      <span
        v-if="campaign.overlay_copy"
        :class="`${headlineSize} ad-content-copy font-weight-normal mb-0 p-4`"
        v-html="campaign.headline"
      ></span>
    </span>
  </a>
</template>

<script>
export default {
  props: {
    slotName: {
      type: String,
      default: null
    },
    headlineSize: {
      type: String,
      default: 'h3'
    },
    campaign: {
      type: Object,
      default () {
        return {
          ref: null,
          name: null,
          bgcolor: null,
          textcolor: null,
          image: null,
          headline: null,
          overlay_copy: false,
          click_url: null
        }
      }
    },
    variant: {
      type: String,
      default: 'default'
    }
  }
}
</script>